import { render, staticRenderFns } from "./AccountsViewPlayer.vue?vue&type=template&id=2bf1fd22"
import script from "./AccountsViewPlayer.vue?vue&type=script&lang=js"
export * from "./AccountsViewPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports